module.exports = __webpack_public_path__ + "static/img/商品轮播图@2x.d900301.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/商品轮播图@2x.png
// module id = cQgM
// module chunks = 192